var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container overflow-hidden pt-5"},[_c('img',{staticClass:"img-fluid pt-3",attrs:{"src":require("@/assets/img/something-went-wrong.svg"),"alt":""}}),_vm._v(" "),_c('router-link',{staticClass:"btn-black-lg px-5",attrs:{"to":"/"}},[_vm._v("Back To Home")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664290e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Error/somethingWentWrong.vue
// module id = null
// module chunks = 